<script>
import ProNav from '$common/ProNav'
import bannerImg from '@/assets/img/virtual_bg.jpg'
import scholarshipsImg from '@/assets/img/scholarshipsavailable.jpg'
import weeklyImg from '@/assets/img/weeklycodingsession.jpg'
import classImg from '@/assets/img/apply_banner.jpg'
import underline from '@/assets/svg/virtual_underline.svg'

export default {
  name: 'SplashMain',
  components: {
    'pro-nav': ProNav,
  },
  data() {
    return {
      // bannerImg,
      scholarshipsImg,
      weeklyImg,
      classImg,
      underline,
      bannerImg,
      course: '',
    }
  },
  methods: {
    showScholarshipInfoModal() {
      this.$modals.show({
        name: 'scholarship-info',
      })
    }
  },
  mounted () {
    setTimeout(() => {
      // due to the way some of these pages are routed, just wait a second before displaying the login modal in case a user is actually logged in
      if (this.$route.params.login == true && !this.$store.state.user) this.$modals.show({name: 'login'})
    }, 1000)
  },
}
</script>

<template lang="pug">
  .info-main-main.main
    .info-main-container.main-container
      pro-nav
      .content
        .header
          .image(
            :style='{backgroundImage: `url(${bannerImg})`}'
          )
          .copy
            .title.font-1-bold 
              span.underline(
                :style='{backgroundImage: `url(${underline})`}'
              ) VIRTUAL 
              span.second-line CODING SESSIONS
            //- .subtitle  
              span • Beginner to Advanced  
              //- span • Ages 7-18  
              span • Code from Anywhere in the World
            //- .btn-row
              a(href="https://virtual.southbendcodeschool.com/")
                .button.pro-button.major.big-btn Virtual Coding Portal
              router-link(
                :to='{name: "GiftCard"}'
              )
                .button.pro-button.major.big-btn Buy Gift Card
        .body.img-left
          img(
            :src='weeklyImg'
          )
          .copy
            .title.font-1-bold Coding For Adult Learners (Ages 18+)
            .text Intro to Careers and Coding is a 4 session coding program designed to introduce lifelong learners, ages 18 and older, to computer science skills. This course is perfect for participants who are interested in coding, whether that be for educational purposes, workforce retraining, skills development, or general interest.
              ul
                li
                  b A useful onramp to coding skills. 
                  span Whether it's for educational purposes, workforce retraining, skills development, or general interest.
                li
                  b No experience necessary. 
                  span This course is for the novices and those just getting started with coding.
                li
                  b Learn from the pros. 
                  span Classes are taught LIVE by a professional programmer. Participants receive guidance and relevant insights into the tech industry. 
                li
                  b Get hands-on experience. 
                  span Designed for the individual looking to gain some guided experience with coding, participants learn by “doing”.
                li
                  b Discover career pathways. 
                  span There are many different types of programming languages and career pathways. Learn which ones spark your interest.
            
              .course(
                @click='course = course == "careersAndCoding" ? "" : "careersAndCoding"'
              ) Intro to Careers and Coding (18+)
                .button.pro-button.major 
                  span Details
                  i.material-icons {{course == "careersAndCoding" ? "keyboard_arrow_up" : "keyboard_arrow_down"}}
              .details(
                v-if='course == "careersAndCoding"'
              ) Each cohort consists of four, 90-minutes classes from 7:00 PM - 8:30 PM EST. 
                .time 
                  b Dates Available
                  //- p Wednesdays | 7:00 pm - 8:30 pm est
                  ul 
                    li September Cohort: 9/14, 9/21, 9/28, 10/5
                    li October Cohort: 10/12, 10/19, 10/26, 11/2
              .bottom-button
                a(href="https://app.southbendcodeschool.com/apply?student=adult")
                  .button.pro-button.major.big-btn Sign Up
        .body.img-right
          .copy
            .title.font-1-bold Coding For Kids and Teens (Ages 7-18)
            .text Learn valuable tech skills from awesome coding instructors, weekly!
              ul 
                li 
                  b All levels of experience are welcome! 
                  span An innovative environment for beginner to advanced coders.
                li 
                  b Practice professional programmer techniques 
                  span (ex. writing clean code, debugging, and documentation).
                li 
                  b Finish with a clear deliverable. 
                  span Participants build tech projects that demonstrate the skills that they learn.
                li 
                  b Start coding on your first day. 
                  span No class lectures; participants apply the skills that they’re learning right away.
                li 
                  b Work with rockstar coding instructors 
                  span who help to explain the complicated parts and give participants academic and industry insight into the world of technology.  
              //- .course(
              //-   @click='course = course == "scratchYoung" ? "" : "scratchYoung"'
              //- ) Scratch Game Design for Beginners (ages 7-10)
              //-   .button.pro-button.major 
              //-     span Details
              //-     i.material-icons {{course == "scratchYoung" ? "keyboard_arrow_up" : "keyboard_arrow_down"}}
              //- .details(
              //-   v-if='course == "scratchYoung"'
              //- ) Designed for new coders ages 7-10. Students will be introduced to the fundamental coding concepts through game design.
              //-   .time 
              //-     b Dates Available:
              //-     p Mondays | 4:00pm - 5:30pm
              //-     p Mondays | 5:45pm - 7:15pm 
              //-     ul
              //-       li February Session:  2/1, 2/8, 2/22, 3/1 
              //-       li March Session: 3/8, 3/15, 3/22, 3/29
              //-       li April Session: 4/12, 4/19, 4/26, 5/3
              //- .course(
              //-   @click='course = course == "scratchOld" ? "" : "scratchOld"'
              //- ) Scratch Game Design Advanced (ages 10-12)
              //-   .button.pro-button.major 
              //-     span Details
              //-     i.material-icons {{course == "scratchOld" ? "keyboard_arrow_up" : "keyboard_arrow_down"}}
              //- .details(
              //-   v-if='course == "scratchOld"'
              //- )  Great for students ages 10-12 who have some coding experience but want to learn further coding concepts through game design.
              //-   .time 
              //-     b Dates Available
              //-     p Mondays | 5:45 pm - 7:15 pm 
              //-     ul
              //-       li February Session: 2/1, 2/8, 2/22, 3/1 
              //-       li March Session: 3/8, 3/15, ,3/22, 3/29
              //-       li April Session: 4/12, 4/19, 4/26, 5/3
              //- .course(
              //-   @click='course = course == "arcade" ? "" : "arcade"'
              //- ) Arcade Game Design (ages 13-18)
              //-   .button.pro-button.major 
              //-     span Details
              //-     i.material-icons {{course == "arcade" ? "keyboard_arrow_up" : "keyboard_arrow_down"}}
              //- .details(
              //-   v-if='course == "arcade"'
              //- ) Teens build classic arcade games from start to finish that can be played over and over again.
              //-   .time 
              //-     b Dates Available:
              //-     p Tuesdays | 5:45pm - 7:15pm
              //-     ul
              //-       li February Session:  2/2, 2/9, 2/23, 3/2
              //-       li March Session: 3/9, 3/16, 3/23, 3/30
              //-       li April Session: 4/13, 4/20, 4/27, 5/4
              //- .course(
              //-   @click='course = course == "beginnerWeb" ? "" : "beginnerWeb"'
              //- ) Intro to Web Development Beginner (ages 10-12)
              //-   .button.pro-button.major 
              //-     span Details
              //-     i.material-icons {{course == "beginnerWeb" ? "keyboard_arrow_up" : "keyboard_arrow_down"}}
              //- .details(
              //-   v-if='course == "beginnerWeb"'
              //- ) This is designed for students who have never coding before but want to learn the fundamentals of coding concepts through web-development. Perfect for students ages 10-12.
              //-   .time 
              //-     b Dates Available
              //-     p Mondays | 4:00 pm - 5:30 pm
              //-       li September Sessions: 9/14, 9/21, 9/28, 10/05
              //-       li October Sessions: 10/12, 10/19, 10/26, 11/2
              //-       li November Sessions: 11/09, 11/16, 11/30, 12/07
              //- .course(
              //-   @click='course = course == "intermediateWeb" ? "" : "intermediateWeb"'
              //- ) Intro to Web Development Intermediate (ages 13-18)
              //-   .button.pro-button.major 
              //-     span Details
              //-     i.material-icons {{course == "intermediateWeb" ? "keyboard_arrow_up" : "keyboard_arrow_down"}}
              //- .details(
              //-   v-if='course == "intermediateWeb"'
              //- ) This provides a deeper dive into HTML, CSS and JavaScript to create interactive and responsive websites.
              //-   .time 
              //-     b Dates Available
              //-     p Wednesdays | 5:45 pm - 7:15 pm
              //-     ul
              //-       li September Session:  9/16, 9/23, 9/30, 10/07
              //-       li October Session: 10/14, 10/21, 10/28, 11/04
              //-       li November Session: 11/11, 11/18, 12/02, 12/09
              //- .course(
              //-   @click='course = course == "python" ? "" : "python"'
              //- ) Python Programming (ages 13-18)
              //-   .button.pro-button.major 
              //-     span Details
              //-     i.material-icons {{course == "python" ? "keyboard_arrow_up" : "keyboard_arrow_down"}}
              //- .details(
              //-   v-if='course == "python"'
              //- ) Here students will learn the fundamental coding concepts and practice good coding form while creating animations and games. This is designed for students who have degree of coding experience. 
              //-   .time 
              //-     b Dates Available
              //-     p Tuesdays | 5:45 pm - 7:15 pm 
              //-     ul
              //-       li September Session: 9/15, 9/22, 9/29, 10/06
              //-       li October Session:  10/13, 10/20, 10/27, 11/3
              //-       li November Session: 11/09, 11/16, 11/30, 12/7

              //- .course(
              //-   @click='course = course == "nextLevel" ? "" : "nextLevel"'
              //- ) Next Level Coding (ages 13-18)
              //-   .button.pro-button.major 
              //-     span Details
              //-     i.material-icons {{course == "nextLevel" ? "keyboard_arrow_up" : "keyboard_arrow_down"}}
              //- .details(
              //-   v-if='course == "nextLevel"'
              //- ) Students with significant coding experience can work on individual passion projects and ideas with the help of an instructor to further develop the coding skills they already have. 
              //-   .time 
              //-     b Dates Available
              //-     p Tuesdays | 5:45 pm - 7:15 pm 
              //-     ul 
              //-       li September Session: 9/15, 9/22, 9/29, 10/06
              //-       li October Session: 10/13, 10/20, 10/27, 11/3
              //-       li November Session: 11/10, 11/17, 12/01, 12/08
              .bottom-button
                a(href="https://virtual.southbendcodeschool.com/")
                  .button.pro-button.major.big-btn.virtual Virtual Coding Portal
          img(
            :src='scholarshipsImg'
          )
        .body
          .copy
            .title.font-1-bold Scholarships Available
            .text At SBCS we believe that technology education should be accessible for all students. Through our community partners, we are able to provide full and partial scholarships for all of our virtual classes. More information on our scholarship program can be found here. 
              .bottom-button
                .button.pro-button.major.big-btn(
                  @click='showScholarshipInfoModal'
                ) FAQ
        //- .body
        //-   .copy
        //-     .title.font-1-bold Classes are guided and taught LIVE by a Code School instructor
        //-     .text We know that e-learning has presented a new way of doing things for both students and parents/guardians. We wanted to be sure to create a program where students felt engaged and parents/guardians could take comfort in knowing that their students would still be receiving the direct attention they need while learning.
        //- .body
        //-   .copy
        //-     .title.font-1-bold Meet the Instructors
        //-     .text Our instructors have real-world experience and love teaching the next generation. Learn more about the talented people teaching our virtual coding sessions!
        //-       .bottom-button
        //-         a.button.pro-button.major.big-btn(
        //-           href='https://medium.com/south-bend-code-school/what-it-takes-to-be-a-code-school-instructor-c9f350ce0f5'
        //-           target='blank'
        //-         ) Learn More
        .body
          .copy
            .title.font-1-bold Class sizes are limited to protect individualized learning experiences
            .text We decided to limit our class sizes in order to guarantee that our instructors can work with each student individually during the time of each class.
        .body
          .copy
            .title.font-1-bold About South Bend Code School
            .text South Bend Code School’s goal is to reform technology education for students ages 7 to 18. We run after-school coding programs and partner with elementary, middle, and high schools. We want to make learning how to code accessible to all and ensure that all of our students feel welcome. We worked with over 1,000 students (40% female and 40% underrepresented minorities) since our inception in 2015. 
              //- .bottom-button.get-started
              //-   router-link(
              //-     :to='{name: "ApplyMain"}'
              //-   ) 
              //-     .button.pro-button.major.big-btn Get Started
        .footer © South Bend Code School, LLC

</template>

<style lang="sass" scoped>
@import '$styles/form.sass'
@import '$styles/transitions.sass'
@import '$styles/main.sass'
.info-main-main
  .info-main-container
    .content
      padding-bottom: 2rem
      .header
        height: 400px
        .image
          background-color: $blue
          background-position: top
        .copy
          background-color: transparent
          grid-template-rows: auto auto 1fr
          .title
            padding-top: 50px
            padding-left: 6vw
            .second-line
              margin-top: 1rem
              @media(max-width:700px)
                margin-top: 0
          .subtitle
            padding-left: 6vw
            color: white
            @media(min-width:950px)
              padding-top: 1rem
            span
              margin-right: 1rem
              @media(max-width:700px)
                display: block
          .btn-row
            padding-left: 6vw
            padding-top: 2rem
            display: flex
            a
              .button
                margin-right: 1rem
                width: fit-content
                padding-left: 2rem
                padding-right: 2rem 
                white-space: nowrap
            @media (max-width: 700px)
              display: block
              .button
                margin-bottom: 1rem
      .body
        &.adult-banner
          // margin: 0 auto !important
          .copy
            padding: 1rem
            .title
              color: $orange
            .text
              padding-bottom: 1rem
        &.img-left
          grid-template-columns: 40% 1fr
        &.img-right
          grid-template-columns: 1fr 40%
          @media (max-width: 700px)
            img
              grid-area: img
            .copy
              grid-area: copy
            grid-template-areas: "img" "copy"
        img
          width: 100%
        .copy
          .title
            font-family: $font-2
            margin-bottom: 1rem
            font-size: 2rem
            &.head-room
              margin-top: 2rem
          .text
            .bottom-button
              margin-top: 1rem
            .course
              font-weight: 600
              color: $orange
              margin-top: 1rem
              cursor: pointer
              display: grid
              grid-template-columns: auto 1fr
              .button
                margin-left: 1rem
                height: 1.5rem
                padding: 0 0.25rem 0 0.5rem
                display: inline-grid
                min-width: auto
                grid-template-columns: 1fr auto
                align-content: center
                justify-content: center
                span
                  padding-top: 0.125rem
            .details
              margin-left: 1rem
              margin-top: 0.5rem
              .time
                margin-top: 1rem
        @media(max-width:700px)
          grid-template-columns: 100% !important
.button.pro-button.major
  &.big-btn
    width: 145px
    font-size: 1.25rem
    font-weight: 600
  &.virtual
    width: fit-content
a
  text-decoration: none
</style>
